import * as React from 'react';
import * as Sebrae from '@sebrae/react-core';

export const ContentContext = React.createContext();

export const ShowContentManageClassProvider = ({ children }) => {
  const { getQueryString } = Sebrae.useRouter();
  const [showContentManageClass, setShowContentManageClass] =
    React.useState(() => getQueryString('manageClass') === 'true');

  const [updateClasses, setUpdateClasses] = React.useState(false);
  const [showManagerRegional, setShowManageRegional] = React.useState(
    () => getQueryString('manageRegional') === 'true',
  );
  return (
    <ContentContext.Provider
      value={{
        showContentManageClass,
        setShowContentManageClass,
        updateClasses,
        setUpdateClasses,
        showManagerRegional,
        setShowManageRegional,
      }}
    >
      {children}
    </ContentContext.Provider>
  );
};
